import { withRequestDeadline } from "./request-deadline";

// Longer than the route's 60-second maximum; aborting only ends our wait,
// it cannot guarantee cancellation or rollback of a CRM write.
export const CLIENT_SUBMISSION_TIMEOUT_MS = 70_000;
export const UNCONFIRMED_SUBMISSION_MESSAGE = "We could not confirm your request. It may have been received. Please call 289-748-9666 during business hours before sending it again.";

export function unconfirmedSubmissionError() {
  const error = new Error(UNCONFIRMED_SUBMISSION_MESSAGE);
  error.code = "submission_unconfirmed";
  return error;
}

// A lost response does not prove a failed CRM write. Never retry a POST here.
// Keep the response shape so each form can retain its own field-error mapping.
export async function submitCrmForm(endpoint, options) {
  let response;
  let result;
  try {
    ({ response, result } = await withRequestDeadline(async (signal) => {
      const response = await fetch(endpoint, { ...options, signal });
      return { response, result: await response.json() };
    }, CLIENT_SUBMISSION_TIMEOUT_MS));
  } catch {
    throw unconfirmedSubmissionError();
  }

  if (result && result.success === false && typeof result.error === "string" && result.error.trim()) {
    return { response, result };
  }

  const leadId = result?.data?.leadId || result?.data?.project?.projectId || result?.data?.project?.id;
  const stableLeadId = (typeof leadId === "string" && leadId.trim().length > 0)
    || (typeof leadId === "number" && Number.isFinite(leadId) && leadId > 0);
  if (!response.ok || result?.success !== true || !stableLeadId) {
    throw unconfirmedSubmissionError();
  }
  return { response, result };
}
